function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'cerises': 'url("//www.entre2gourmands.com/cdn/shop/files/couleur_cerises_68x.png?809")','rayures-lilas': 'url("//www.entre2gourmands.com/cdn/shop/files/couleur_rayures_lilas_68x.png?809")','petites-fleurs-multi': 'url("//www.entre2gourmands.com/cdn/shop/files/couleur_petites_fleurs_multi_68x.png?809")','fleurs-blanches': 'url("//www.entre2gourmands.com/cdn/shop/files/couleur_fleurs_blanches_68x.png?809")','fleurs-abstraites': 'url("//www.entre2gourmands.com/cdn/shop/files/couleur_fleurs_abstraites_68x.png?809")','fleurs-boho': 'url("//www.entre2gourmands.com/cdn/shop/files/couleur_fleurs_boho_68x.png?809")','leopard': 'url("//www.entre2gourmands.com/cdn/shop/files/couleur_leopard_68x.png?809")','lignes-roses': 'url("//www.entre2gourmands.com/cdn/shop/files/couleur_lignes_roses_68x.png?809")','noir-cotele': 'url("//www.entre2gourmands.com/cdn/shop/files/couleur_noir_cotele_68x.png?809")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
